module.exports = __webpack_public_path__ + "img/蓝莓.7f1aecc0.png";